import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconCircleComponent } from '@core/getting-started-legacy';
import { IconComponent } from '@core/user-interface-legacy';

export interface StepperStep {
  id: string;
  label: string;
  active: boolean;
  completed: boolean;
}

@Component({
  styleUrl: './stepper.component.less',
  templateUrl: './stepper.component.html',
  selector: 'tl-stepper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconCircleComponent, IconComponent, NgTemplateOutlet],
})
export class StepperComponent {
  public steps = input.required<StepperStep[]>();
}
